import React from 'react';
import { Col } from 'antd';

import {
	FooterButtons,
	RiskFactorsTable,
	RiskFactorCategories,
	PreventiveMeasuresTable,
	FollowUpPreventiveMeasuresTable
} from './components';
import { GeneralInformation } from '../components/GeneralInformation';
import { Comment } from '../components/Comment';
import { HeaderResult } from '../components/HeaderResult';
import { Resolution886ResultEnum } from '@/enums/Resolution886';

import * as S from './styles';

export function InitialVersion(): JSX.Element {
	return (
		<S.DefaultResultContent>
			<HeaderResult title="Resolution 886" />
			<Col>
				<GeneralInformation />
			</Col>
			<Col style={{ marginTop: '24px' }}>
				<RiskFactorsTable />
			</Col>
			<Col style={{ marginTop: '24px' }}>
				<RiskFactorCategories />
			</Col>
			<Col>
				<PreventiveMeasuresTable />
			</Col>
			<Col>
				<FollowUpPreventiveMeasuresTable />
			</Col>
			<Col>
				<Comment result_type={Resolution886ResultEnum.INITIAL} />
			</Col>
			<Col>
				<FooterButtons />
			</Col>
		</S.DefaultResultContent>
	);
}
